/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onbilgi_S8_HeadingInputs */

const tr_onbilgi_s8_heading = /** @type {(inputs: Onbilgi_S8_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`8. Cayma Hakkını Kullanım Usulü`)
};

const en_onbilgi_s8_heading = /** @type {(inputs: Onbilgi_S8_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`8. Procedure for Exercising the Right of Withdrawal`)
};

const de_onbilgi_s8_heading = /** @type {(inputs: Onbilgi_S8_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`8. Ausübung des Widerrufsrechts`)
};

const ru_onbilgi_s8_heading = /** @type {(inputs: Onbilgi_S8_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`8. Порядок реализации права на отказ`)
};

/**
* | output |
* | --- |
* | "8. Procedure for Exercising the Right of Withdrawal" |
*
* @param {Onbilgi_S8_HeadingInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const onbilgi_s8_heading = /** @type {((inputs?: Onbilgi_S8_HeadingInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onbilgi_S8_HeadingInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_onbilgi_s8_heading(inputs)
	if (locale === "de") return de_onbilgi_s8_heading(inputs)
	if (locale === "ru") return ru_onbilgi_s8_heading(inputs)
	return tr_onbilgi_s8_heading(inputs)
});